import { Ref, forwardRef } from "react"
import { Form, Formik, FormikProps } from "formik"
import * as yup from "yup"
import { CreateUpdateUserGroupFormContent } from "./CreateUpdateUserGroupFormContent"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { CreateUpdateUserGroup, CreateUpdateUserGroupFormValues, HistoryType } from "../userGroupsTypes"

type CreateUpdateUserGroupFormProps = Readonly<{
    initialValues?: CreateUpdateUserGroupFormValues | null
    history?: HistoryType
    onSubmit: (formData: CreateUpdateUserGroup) => void
}>
type FormikRef = Ref<FormikProps<CreateUpdateUserGroupFormValues>>

export const CreateUpdateUserGroupForm = forwardRef(
    ({ initialValues, history, onSubmit }: CreateUpdateUserGroupFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const defaultInitialValues = {
            name: "",
            isActive: true,
            domains: [],
            billReceivers: [],
        }

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("required-field")),
        })

        function handleSubmit(values: CreateUpdateUserGroupFormValues) {
            const modifyData = {
                ...values,
                domains: values.domains.map((domain) => ({
                    id: domain.id,
                })),
                billReceivers: values.billReceivers.map((domain) => ({
                    id: domain.id,
                })),
            }

            onSubmit(modifyData)
        }

        return (
            <>
                <Formik<CreateUpdateUserGroupFormValues>
                    enableReinitialize
                    initialValues={initialValues ? initialValues : defaultInitialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    innerRef={ref}
                    validateOnBlur={false}
                    validateOnChange={false}
                >
                    <Form>
                        <CreateUpdateUserGroupFormContent history={history} />
                    </Form>
                </Formik>
            </>
        )
    },
)
